<div class="waec-page-header">
  <img
    class="waec-page-header-image"
    src="/assets/icons/Recovery_highlighted.svg"
    alt="Highighted_Recovery"
  />
  <h3 class="waec-page-header-text">{{'PROVISIONING.RECOVER_CANDIDATE_NUMBER.HEADER' | translate}}</h3>
</div>

<div class="page-container" nz-row>
  <!-- PROVISSIONING -->
  <div class="" id="">
    <nz-card class="ant-card-body-main" [nzBordered]="false">
      <div nz-row>
        <div
          nz-col
          nzXs="24"
          nzSm="24"
          nzMd="24"
          nzLg="16"
          nzXl="16"
          class="verification_form"
        >
          <h3 class="waec-card-header-text">{{'PROVISIONING.RECOVER_CANDIDATE_NUMBER.CARD_TITLE' | translate}}</h3>
          <div class="span-left">
            {{'PROVISIONING.RECOVER_CANDIDATE_NUMBER.CARD_SUBTITLE' | translate}}
          </div>
        </div>
      </div>

      <div nz-row [nzGutter]="48" nzTitle="Certificate Accessing">
        <div nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="24" nzXl="16">
          <nz-alert
            *ngIf="message"
            [nzType]="'error'"
            [nzMessage]="message"
            nzCloseable
            class="mb-lg"
          ></nz-alert>
          <form
            nz-form
            [formGroup]="recoverExamNoForm"
            (ngSubmit)="chargesNotification()"
          >

            <div nz-row>
              <div nz-col class="gutter-row" nzXs="24">
                 <nz-form-label nzRequired nzFor="country"
                      >{{'GENERAL.COUNTRY' | translate}}</nz-form-label
                    >
                <nz-form-control [nzErrorTip]="'GENERAL.SELECT_COUNTRY' | translate" nzSpan="24">
                      <nz-select formControlName="country" class="v2-select" id="candidate_country" [nzPlaceHolder]="'GENERAL.SELECT_COUNTRY' | translate" name="type"
                        [nzCustomTemplate]="countrySelection" nzDisabled>
                        <nz-option *ngFor="let data of countries" [nzValue]="data.code" [nzLabel]="data.name"
                          nzDisabled>
                        </nz-option>
                      </nz-select>
                      <ng-template #countrySelection let-selected>
                        <img class="selected_country" alt="{{ selected.nzLabel }}" src="https://purecatamphetamine.github.io/country-flag-icons/3x2/{{
                            selected.nzValue
                          }}.svg" height="20" width="20" />
                        {{ selected.nzLabel }}
                      </ng-template>
                    </nz-form-control>
              </div>
            </div>
            <div nz-row class="mt-3" [nzGutter]="{ xs: 8, sm: 16, md: 24, lg: 32 }">
              <div
                nz-col
                class="gutter-row"
                nzXs="24"
                nzSm="24"
                nzMd="12"
                nzLg="12"
                nzXl="12"
              >
                <nz-form-item>
                  <nz-col nzSpan="24">
                    <nz-form-label nzRequired nzFor="year"
                      >{{'GENERAL.EXAM_YEAR' | translate}}</nz-form-label
                    >
                    <nz-form-control [nzErrorTip]="'GENERAL.SELECT_EXAM_YEAR' | translate">
                      <nz-select
                        [nzShowSearch]="true"
                        formControlName="year"
                        [nzPlaceHolder]="'GENERAL.EXAM_YEAR' | translate"
                        name="year"
                        class="v2-select"
                        id="year"
                        (ngModelChange)="chooseDiet($event); onEnableCheckbox()"
                      >
                        <nz-option
                          *ngFor="let o of dietYears"
                          [nzLabel]="o"
                          [nzValue]="o"
                        ></nz-option>
                      </nz-select>
                    </nz-form-control>
                  </nz-col>
                </nz-form-item>
              </div>
              <div
                nz-col
                class="gutter-row"
                nzXs="24"
                nzSm="24"
                nzMd="12"
                nzLg="12"
                nzXl="12"
              >
                <nz-form-item>
                  <nz-col nzSpan="24">
                    <nz-form-label nzRequired nzFor="exam_type"
                      >{{'GENERAL.EXAM_TYPE' | translate}}</nz-form-label
                    >
                  </nz-col>
                  <nz-col nzSpan="24">
                    <nz-form-control
                      [nzErrorTip]="'GENERAL.PLEASE_SELECT_EXAM_YEAR' | translate"
                    >
                      <nz-select
                        (click)="choosenDiet()"
                        nzName="radiogroup"
                        id="exam_type"
                        class="v2-select"
                        formControlName="exam_type"
                        [nzPlaceHolder]="'GENERAL.EXAM_TYPE' | translate"
                        name="exam_type"
                        (ngModelChange)="setSeries($event); onEnableCheckbox()"
                      >
                        <nz-option
                          *ngFor="let exam of availableExamDiets"
                          [nzLabel]="exam"
                          [nzValue]="exam"
                        >
                        </nz-option>
                      </nz-select>
                    </nz-form-control>
                  </nz-col>
                </nz-form-item>
              </div>
            </div>
            <div nz-row class="negative-margin" [nzGutter]="{ xs: 8, sm: 16, md: 24, lg: 32 }">
              <div
                nz-col
                class="gutter-row"
                nzXs="24"
                nzSm="24"
                nzMd="12"
                nzLg="12"
                nzXl="12"
              >
                <nz-form-item>
                  <nz-col nzSpan="24">
                    <nz-form-label nzRequired nzFor="surname"
                      >{{'GENERAL.SURNAME' | translate}}</nz-form-label
                    >
                    <nz-form-control [nzErrorTip]="'PASSPORT.REGISTER.ENTER_VERIFIER_SURNAME_TOOLTIP' | translate">
                      <input
                        nz-input
                        name="surname"
                        id="surname"
                        class="v2-input"
                        (ngModelChange)="onEnableCheckbox()"
                        aria-disabled="true"
                        formControlName="surname"
                        [placeholder]="'GENERAL.SURNAME' | translate"
                        [readOnly]="!canEditField"
                      />
                    </nz-form-control>
                  </nz-col>
                </nz-form-item>
              </div>
              <div
                nz-col
                class="gutter-row"
                nzXs="24"
                nzSm="24"
                nzMd="12"
                nzLg="12"
                nzXl="12"
              >
                <nz-form-item>
                  <nz-col nzSpan="24">
                    <nz-form-label nzRequired nzFor="firstname"
                      >{{'GENERAL.FIRST_NAME' | translate}}</nz-form-label
                    >
                    <nz-form-control [nzErrorTip]="'GENERAL.ENTER_FIRST_NAME' | translate">
                      <input
                        nz-input
                        name="firstname"
                        id="firstname"
                        class="v2-input"
                        (ngModelChange)="onEnableCheckbox()"
                        formControlName="firstname"
                        [placeholder]="'GENERAL.FIRST_NAME' | translate"
                        [readOnly]="!canEditField"
                      />
                    </nz-form-control>
                  </nz-col>
                </nz-form-item>
              </div>
            </div>

            <div nz-row class="negative-margin" [nzGutter]="{ xs: 8, sm: 16, md: 24, lg: 32 }">
              <div
                nz-col
                class="gutter-row"
                nzXs="24"
                nzSm="24"
                nzMd="12"
                nzLg="12"
                nzXl="12"
              >
                <nz-form-item>
                  <nz-col nzSpan="24">
                    <nz-form-label nzFor="othername">{{'PROVISIONING.RECOVER_CANDIDATE_NUMBER.OTHERNAME' | translate}}</nz-form-label>
                    <nz-form-control [nzErrorTip]="'PROVISIONING.RECOVER_CANDIDATE_NUMBER.ENTER_OTHERNAME' | translate">
                      <input
                        nz-input
                        name="othername"
                        id="othername"
                        class="v2-input"
                        formControlName="othername"
                        [placeholder]="'PROVISIONING.RECOVER_CANDIDATE_NUMBER.OTHERNAME' | translate"
                        [readOnly]="!canEditField"
                      />
                    </nz-form-control>
                  </nz-col>
                </nz-form-item>
              </div>
              <div
                nz-col
                class="gutter-row"
                nzXs="24"
                nzSm="24"
                nzMd="12"
                nzLg="12"
                nzXl="12"
              >
                <nz-form-item>
                  <nz-col nzSpan="24">
                    <nz-form-label nzRequired nzFor="Sex">{{'PROVISIONING.RECOVER_CANDIDATE_NUMBER.SEX' | translate}}</nz-form-label>
                    <nz-form-control [nzErrorTip]="'PROVISIONING.RECOVER_CANDIDATE_NUMBER.SELECT_SEX' | translate" nzSpan="24">
                      <nz-select
                        formControlName="sex"
                        [nzPlaceHolder]="'PROVISIONING.RECOVER_CANDIDATE_NUMBER.SEX' | translate"
                        class="v2-select"
                        name="sex"
                        id="sex"
                        (ngModelChange)="onEnableCheckbox()"
                      >
                        <nz-option [nzLabel]="'PROVISIONING.RECOVER_CANDIDATE_NUMBER.MALE' | translate" nzValue="M"></nz-option>
                        <nz-option [nzLabel]="'PROVISIONING.RECOVER_CANDIDATE_NUMBER.FEMALE' | translate" nzValue="F"></nz-option>
                      </nz-select>
                    </nz-form-control>
                  </nz-col>
                </nz-form-item>
              </div>
            </div>
            <div nz-row class="negative-margin" [nzGutter]="{ xs: 8, sm: 16, md: 24, lg: 32 }">
              <div
                nz-col
                class="gutter-row"
                nzXs="24"
                nzSm="24"
                nzMd="24"
                nzLg="24"
                nzXl="24"
              >
                <nz-form-item>
                  <nz-col nzSpan="24">
                    <nz-form-label nzRequired nzFor="dob"
                      >{{'GENERAL.DATE_OF_BIRTH' | translate}}
                    </nz-form-label>
                    <nz-form-control [nzErrorTip]="'GENERAL.SELECT_DOB' | translate">
                      <nz-date-picker
                        class="w-100 v2-date-picker"
                        [nzDisabledDate]="disabledDate_of_Birth"
                        formControlName="dob"
                        [nzPlaceHolder]="'GENERAL.DATE_OF_BIRTH' | translate"
                        id="dob"
                        (ngModelChange)="onEnableCheckbox()"
                      ></nz-date-picker>
                    </nz-form-control>
                  </nz-col>
                </nz-form-item>
              </div>
            </div>

            <nz-form-item>
              <nz-form-control
                [nzErrorTip]="'GENERAL.VERIFY_INFO' | translate"
              >
                <label
                  nz-checkbox
                  [nzDisabled]="isDisableCheckbox"
                  (ngModelChange)="checkButton()"
                  formControlName="validData"
                >
                  <span class="verify_info"
                    >{{'GENERAL.VERIFY_INFO' | translate}}</span
                  >
                </label>
              </nz-form-control>
            </nz-form-item>
            <nz-form-item>
              <nz-col nzSpan="17">
                <nz-form-control>
                  <button
                    nz-button
                    nzType="primary"
                    class="v2-btn-primary"
                    [nzLoading]="loading"
                    [disabled]="checkFormValidity()"
                    nzSize="large"
                  >
                    {{'PROVISIONING.RECOVER_CANDIDATE_NUMBER.SUBMIT_BTN' | translate | uppercase}}
                  </button>
                </nz-form-control>
              </nz-col>
            </nz-form-item>
          </form>
        </div>

        <div nz-col nzXs="24" nzXl="8">
          <app-stats 
          [canEdit]="canEditField" 
          [type]="services.RECOVERY"
          (toggleEditField)="toggleEditField($event)"
          ></app-stats>
        </div>
      </div>
    </nz-card>
  </div>
</div>


<!-- MODE OF PAYMENT Information -->
<app-payment
  *ngIf="paymentModal"
  (closeModal)="cancelPaymentOptionsModal()"
  (confirmSubmit)="initiateWallet($event)"
  [action]="'access'"
  [Cost]="retrievalCost"
></app-payment>

<!-- Wallet Credit -->
<nz-modal
  [nzStyle]="{ top: '20px' }"
  [nzMask]="true"
  nzMaskClosable="false"
  nzWidth="400px"
  nzClosable="true"
  [(nzVisible)]="walletCreditModal"
  [nzTitle]="'GENERAL.FUND_WALLET' | translate"
  [nzContent]="modalContentbillingpayment"
  (nzOnCancel)="cancelmodalContentbillingpayment()"
>
  <ng-template #modalContentbillingpayment>
    <app-billing-modal
      (successResponse)="initiateFundingWallet($event)"
      [Cost]="retrievalCost"
    ></app-billing-modal>
  </ng-template>
  <div *nzModalFooter></div>
</nz-modal>


<!-- OTP Modal  -->
<nz-modal
  [nzMask]="true"
  nzMaskClosable="false"
  [(nzVisible)]="otpModal"
  [nzTitle]="modalotpTitle"
  [nzContent]="modalotpContent"
  [nzFooter]="null"
  nzCentered="true"
>
  <ng-template #modalotpTitle>
    {{ accessFormData ? ('PROVISIONING.PROVISION.NOTIFICATION' | translate) : ('PROVISIONING.PROVISION.OOPS' | translate) }}
  </ng-template>
  <ng-template #modalotpContent>
    <p>
      {{ message }}
    </p>
    <form nz-form [formGroup]="otpFormGroup" (submit)="submitOtp()">
      <nz-form-item *ngIf="accessFormData">
        <nz-col nzSpan="24">
          <nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="16" nzXl="16">
            <nz-form-label nzFor="otp">{{'GENERAL.ENTER_CODE' | translate}}</nz-form-label>
          </nz-col>
          <nz-col nzSpan="24">
            <nz-form-control [nzErrorTip]="'PROVISIONING.PROVISION.OTP_TEXT' | translate">
              <input
                nz-input
                name="otp"
                id="otp"
                formControlName="otp"
                [nzPlaceHolder]="'GENERAL.ENTER_CODE' | translate"
              />
            </nz-form-control>
          </nz-col>
        </nz-col>
      </nz-form-item>

      <nz-form-item *ngIf="!accessFormData">
        <nz-col nzSpan="24">
          <button
            nz-button
            nzType="primary"
            [disabled]="loading"
            [nzLoading]="loading"
            (click)="showNotify()"
          >
            {{'PROVISIONING.CERTIFICATES.REQUEST_CONSENT' | translate | uppercase}}
          </button>
        </nz-col>
        <br />
        <br />
        <nz-col nzSpan="24">
          <p>
            <a routerLink="/ticket/{{ accessing_id }}" class="log_ticket"
              >{{'PROVISIONING.PROVISION.LODGE_COMPLAINT' | translate}}</a
            >
          </p>
        </nz-col>
      </nz-form-item>
      <nz-form-item
        class="mt-2 mb-2"
        *ngIf="accessFormData"
      >
        <nz-col nzSpan="24">
          <nz-form-control>
            <button nz-button nzType="secondary" (click)="cancelOtpModal()">
              {{'GENERAL.CANCEL' | translate | uppercase}}
            </button>
            <button
              nz-button
              nzType="primary"
              [disabled]="loading"
              [nzLoading]="loading"
            >
              {{'GENERAL.VERIFY' | translate | uppercase}}
            </button>
          </nz-form-control>
        </nz-col>
      </nz-form-item>
      <nz-form-item
        class="mb-2 mt-2"
        *ngIf="accessFormData?.codeExpiryTime"
      >
        <n-col nzSpan="24">
          <p class="text-xs ion-text-center mt-4">
            <i>{{'PROVISIONING.PROVISION.CODE_EXPIRY' | translate}} {{ accessFormData?.codeExpiryTime }}</i>
          </p>
        </n-col>
      </nz-form-item>
    </form>
  </ng-template>
</nz-modal>

<!-- SERVICE CHARGE / INFORMATION CONFIRMATION MODAL -->
<digicert-service-charge
  *ngIf="userInformationModal"
  [candidateInformationForm]="candidateInformation"
  [serviceCharge]="serviceCharge"
  [costInUnit]="retrievalCost"
  [feature]="services.RECOVERY"
  (closeModal)="closeConfirmInformation($event)"
  (makePayment)="submit()"
></digicert-service-charge>


<!-- TERMS MODAL -->
 <digicert-process-steps
  *ngIf="termsConditionsModal"
  [feature]="services.TERMS"
  [service]="services.ACCESS"
  (closeModal)="dismissModal()"
  (acceptTerms)="agreeToTerms()"
></digicert-process-steps>


<!-- PROCESS FLOW MODAL -->
 <digicert-process-steps
  *ngIf="processStepsModal"
  [feature]="services.RECOVERY"
  [serviceCharge]="serviceCharge"
  [costInUnit]="retrievalCost"
  [userType]="userTypes.USER | lowercase"
  [candidateInformation]="candidateInformation"
  [retrievedCandidateData]="retrievedCandidateData"
  [steps]="step"
  [topUp]="topUp"
  (successfulFlow)="confirmPayment()"
  (withdrawFromWallet)="retrievalFormSubmit($event)"
  (closeModal)="closeProcessStepsModal($event)"
  (requestVerification)="requestVerification($event)"
 ></digicert-process-steps>

<!-- USER VERIFICATION -->
 <app-user-verification
  *ngIf="userInformationVerification"
  (successResponse)="retrievalFormSubmit(displayPayment == true)"
  (closeModal)="cancelMeansofIdentificationModal($event)"
  [step]="userInformationWindowStep"
  [year]="Year"
  [actions]="actions"
 ></app-user-verification>


<!-- EXAM COUNTRY SETUP MODAL -->
<app-exam-country-setup *ngIf="examCountrySetupModal"
  (closeModal)="closeExamCountrySetupModal()"></app-exam-country-setup>